var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"languages"},_vm._l((_vm.languages),function(language,index){return _c('h5',{key:index,staticClass:"title",class:[_vm.titleClass, _vm.getActiveLanguageClass(language.code)],on:{"click":function($event){return _vm.onChangeLanguage(language.code)}}},[_vm._v(" "+_vm._s(language.slug)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }